import { SectionHeader } from "app/components/sectionHeader";
import * as React from "react";
import { useUserDetails } from "./useUserDetails";
import { InputEdit } from "app/components/inputEdit/InputEdit";
import { CredsConfirmModal } from "../credsConfirmModal/credsConfirmModal";
import { Avatar, Divider } from "@nextui-org/react";
import { AsButton } from "app/subframe";
import { Loading } from "app/components/loading/loading";

export interface UserDetailsProps {}

export const UserDetails: React.FC<UserDetailsProps> = ({}) => {
  const {
    user,
    onUpdateUser,
    showReAuthModal,
    setShowReAuthModal,
    handleReauthAndSubmit,
    handleAvatarChange,
    isLoading,
  } = useUserDetails();

  return (
    <>
      {isLoading && (
        <Loading
          containerClassName="!absolute !top-0 left-0 w-full !z-[1000]"
          showBackdrop
          type="dark"
        />
      )}
      <CredsConfirmModal
        isOpen={showReAuthModal}
        onOpenChange={setShowReAuthModal}
        onSubmit={handleReauthAndSubmit}
      />
      <div className="flex flex-col w-full gap-4">
        <SectionHeader title="User Details" />
        <div className="p-4 gap-4 flex flex-col rounded border border-neutral-50">
          <div className="flex flex-col gap-4">
            <div className="flex gap-4 items-center">
              <Avatar className="w-14 h-14 rounded" src={user?.avatar} />
              <input
                type="file"
                accept="image/*"
                id="avatar"
                style={{ display: "none" }}
                onChange={handleAvatarChange}
              />
              <AsButton
                variant="neutral-secondary"
                onClick={() => document.getElementById("avatar")?.click()}
                text="Upload picture"
              />
            </div>
            <Divider className="bg-neutral-50" />
          </div>
          <div className="flex flex-col gap-10">
            <InputEdit
              defaultValue={user?.name}
              label="Name"
              name="name"
              onSave={(value) => onUpdateUser({ ...value })}
              valueClassName="text-body-bold font-body-bold text-neutral-900"
            />
            <div className="relative">
              <InputEdit
                key={new Date().getTime()}
                defaultValue={user?.email}
                label="Email"
                name="email"
                onSave={(value) => onUpdateUser({ ...value })}
                valueClassName="text-body-bold font-body-bold text-neutral-900 w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
